export default __webpack_public_path__ + "pizza.db8a26b7.svg";